import { ButtonHTMLAttributes, FC } from 'react';
import Button from './Button';
import { IDataTestId } from '../../../../../custom';
import cn from 'utils/cn';
import './Button.css';

const CancelButton: FC<
  ButtonHTMLAttributes<HTMLButtonElement> & IDataTestId & { label?: string | undefined }
> = (props) => {
  return (
    <Button
      {...props}
      variant="transparent"
      testId={props?.['data-testid'] || 'cancel-btn'}
      onClick={props.onClick}
      label={props?.label || 'Cancel'}
      className={cn('kobai-button--cancel', props?.className)}
    />
  );
};

export default CancelButton;
